<template>
  <div class="flex col gap-4">
    <AppLink
      v-for="country in $branch.visaCountries"
      class="flex items-center gap-3"
      :to="getVisaCountryPath(country)"
      plain
    >
      <CountryFlag :code="getVisaCountryIsoCode(country)" />
      {{ $tt(source == 'nav' ? `nav.visa_country_select.option_${country}` : `footer.visa_to_${country}`) }}
    </AppLink>
  </div>
</template>

<script setup lang="ts">
import { getVisaCountryIsoCode, getVisaCountryPath } from '~/helpers/visa-country';
defineProps<{
  source: 'nav' | 'footer';
}>();
</script>